import React from 'react';
import { detailWrap } from 'styles/table';
import dayjs from 'dayjs';
import Action from './Action';
import useDetail from '../useDetail';
import { getUserStatus } from '../utils/status';
import { formatPhoneNumber } from 'utils/format';

function Main() {
  const { user } = useDetail();
  if (!user) return null;

  return (
    <div css={[detailWrap, { marginTop: '24px', position: 'relative' }]}>
      <h3>회원정보</h3>
      {user.status !== 'WITHDRAW' && <Action user={user} />}
      {/* <Action user={user} /> */}
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '24px',
          gap: '0 48px',
        }}
      >
        <ul
          css={{
            '> li': {
              display: 'flex',
              marginBottom: '12px',
            },
            '> li > div': {
              minWidth: '240px',
              display: 'flex',
              gap: '0 8px',
              'p:nth-of-type(1)': {
                fontWeight: 'bold',
              },
              '> p': {
                fontSize: '14px',
              },
            },
          }}
        >
          <li>
            <div>
              <p>회원상태:</p>
              <p>{getUserStatus(user.status)}</p>
            </div>
            <div>
              <p>가입일</p>
              <p>{dayjs(user.signUpDate).format('YYYY-MM-DD')}</p>
            </div>
          </li>

          {/* <li>
            <div>
              <p>아이디:</p>
              <p>{user.ID}</p>
            </div>
            <div>
              <p>이메일:</p>
              <p>{user.email}</p>
            </div>
          </li> */}

          <li>
            <div>
              <p>생년월일:</p>
              <p>{user.birthDate}</p>
            </div>
            <div>
              <p>vms:</p>
              <p>{user.vms || '-'}</p>
            </div>
          </li>
          <li>
            <div>
              <p>휴대폰번호:</p>
              <p>{formatPhoneNumber(user.phone) || '-'}</p>
            </div>
            <div>
              <p>1365:</p>
              <p>{user.id1365 || '-'}</p>
            </div>
          </li>
          <li>
            <div>
              <p>이름:</p>
              <p>{user.name || '-'}</p>
            </div>
            <div>
              <p>이메일:</p>
              <p>{user.email || '-'}</p>
            </div>
          </li>
          <li>
            <div>
              <p>성별:</p>
              <p>{user.gender === 'MALE' ? '남' : '여'}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Main;
